import React, {cloneElement} from 'react';
import {TouchableOpacity} from 'react-native';
import {tID} from '../../../utils/TestIdHelper';
import {useThemedStyles} from '../../../theme';
import makeStyles from './styles';

export default function IconButton({
  style = {},
  onPress,
  leftImage,
  imageSize = 16,
  tintColor,
  buttonSize = 40,
  disabled = false,
}) {
  const styles = useThemedStyles(makeStyles);
  return (
    <TouchableOpacity
      testID={tID('IconButton-TouchableOpacity-Icon')}
      disabled={disabled}
      activeOpacity={1}
      onPress={onPress}
      style={[styles.buttonContainer(buttonSize), style]}
    >
      {cloneElement(leftImage, {
        testID: tID('IconButton-Image-Icon'),
        tintColor,
        width: imageSize,
        height: imageSize,
      })}
    </TouchableOpacity>
  );
}
